import { useState, useEffect } from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import axios from 'axios';
import qs from 'qs';


const Page5IncidencesFinancieresHypPart2 = (props) =>
{
    const blue = '#069BD3';
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/6;

    const [incidencesData, setIncidencesData] = useState(null);

    async function getDatas() {
        // Convertir le numéro d'hypothèse en clé (1 -> h1, 2 -> h2, 3 -> h3)
        const hypotheseMap = { 1: 'h1', 2: 'h2', 3: 'h3' };
        const hypotheseKey = hypotheseMap[props.hypothese];
        const annee_debut = props.user.config_budget.retro_an_deb;
        const annee_fin = props.user.config_budget.prosp_an_fin;

        if (annee_debut === undefined || annee_fin === undefined) {
            console.warn('Les années de début et de fin ne sont pas définies dans la configuration du budget utilisateur.');
            return;
        }

        try {
            const response = await axios.post('https://app-slfinance.fr/api/incidences_financieres_operations.php', qs.stringify({
                action: 'get_consolidated_by_budget_hypothesis_and_years',
                id_budget: props.user.id_budget,
                hypothese: hypotheseKey,
                annee_debut: annee_debut,
                annee_fin: annee_fin
            }));

            if (response.data.status === 1) {
                setIncidencesData(response.data.data);
            } else {
                console.warn('Erreur API:', response.data.message);
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des incidences financières:', error);
        }
    }

    // UseEffect pour recuperer les incidences financieres en fonction de props.hypothese.
    useEffect(() => {
        if (props.hypothese !== null && props.user) {
            getDatas();
        }
    }, [props.hypothese, props.user]);

    const fieldsList = [
        { label: 'Entretien réparations (ER)', key: 'sum_entretien_reparations', isBold: false, isCalculated: false },
        { label: 'Eau/électricité (DEE)', key: 'sum_eau_electricite', isBold: false, isCalculated: false },
        { label: 'Charges de copropriété (DCC)', key: 'sum_charges_copropriete', isBold: false, isCalculated: false },
        { label: 'Taxes foncières (DTFB)', key: 'sum_taxes_foncieres', isBold: false, isCalculated: false },
        { label: 'Taxe/redevance OM (DOM)', key: 'sum_taxe_redevance_om', isBold: false, isCalculated: false },
        { label: 'Assurances (DASS)', key: 'sum_assurances', isBold: false, isCalculated: false },
        { label: 'Autres (DAU)', key: 'sum_autres_depenses', isBold: false, isCalculated: false },
        { label: 'TOTAL Dépenses (TOTDEP)', key: 'sum_total_depenses', isBold: true, isCalculated: true },
        { label: '', key: 'empty_5', isEmpty: true },
        { label: 'Loyers perçus (LOY)', key: 'sum_loyers_percus', isBold: false, isCalculated: false },
        { label: 'Refacturation - Eau/électricité (REE)', key: 'sum_refacturation_eau_electricite', isBold: false, isCalculated: false },
        { label: 'Refacturation - Charges de copropriété (RCC)', key: 'sum_refacturation_charges_copropriete', isBold: false, isCalculated: false },
        { label: 'Refacturation - Taxes foncières (RTFB)', key: 'sum_refacturation_taxes_foncieres', isBold: false, isCalculated: false },
        { label: 'Refacturation - OM (ROM)', key: 'sum_refacturation_om', isBold: false, isCalculated: false },
        { label: 'Refacturation - Assurances (RASS)', key: 'sum_refacturation_assurances', isBold: false, isCalculated: false },
        { label: 'Autres (RAU)', key: 'sum_autres_recettes', isBold: false, isCalculated: false },
        { label: 'TOTAL Recettes (TOTREC)', key: 'sum_total_recettes', isBold: true, isCalculated: true },
        { label: '', key: 'empty_6', isEmpty: true },
        { label: 'Solde annuel frais de gestion (SAFG)', key: 'sum_solde_annuel_frais_gestion', isBold: false, isCalculated: true },
        { label: 'Solde cumulé frais de gestion (SCFG)', key: 'sum_solde_cumule_frais_gestion', isBold: false, isCalculated: true },
        { label: '', key: 'empty_7', isEmpty: true },
        { label: 'Solde d\'opération fin d\'année (SO)', key: 'sum_solde_operation', isBold: true, isCalculated: true }
    ];

    const formatNumber = (value) => {
        if (!value || isNaN(value)) return '';
        const num = parseFloat(value);
        return num.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    };

    // Fonction pour vérifier si une année a des données
    const hasYearData = (row) => {
        return fieldsList.some(field => {
            if (field.isEmpty) return false;
            const value = row[field.key];
            return value !== null && value !== undefined && value !== '' && value !== 0;
        });
    };

    // Filtrer les données pour commencer à la première année avec des données
    const filteredIncidencesData = incidencesData ? incidencesData.filter(hasYearData) : [];
    
    // Calcul dynamique de la largeur des colonnes de données
    const containerWidth = props.width * 0.9; // 90% de la width
    const fixedColumnsWidth = 60 + 150; // Colonne catégorie (60) + colonne libellés (150)
    const availableWidth = containerWidth - fixedColumnsWidth;
    const columnDataWidth = filteredIncidencesData.length > 0 ? Math.max(60, availableWidth / filteredIncidencesData.length) : 60;
    
    // Calcul dynamique de la hauteur des lignes
    const tableHeight = props.height * 0.8; // 80% de la hauteur pour le container du tableau
    const tableHeaderHeight = 100; // Hauteur du header du tableau
    const availableHeightForRows = tableHeight - tableHeaderHeight;
    const emptyRowCount = 3; // Nombre de lignes vides
    const emptyRowHeight = 12; // Hauteur des lignes vides
    const normalRowCount = 22 - emptyRowCount; // 22 lignes au total, 3 vides
    const normalRowHeight = (availableHeightForRows - (emptyRowCount * emptyRowHeight)) / normalRowCount;

    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>
            
            {/* Header */}
            <div style={{display: 'flex', height: '15%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: props.height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>Incidences financières</p>
                    <p style={{color: blue, fontSize: (fontsize+6), marginLeft: 5, fontStyle: 'italic'}}>{props.hypothese !== null ? '(hypothèse '+props.hypothese+')' : ''} - partie 2</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des opérations</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '80%', fontSize: fontsize, overflowY: 'hidden', overflowX: 'hidden'}}>
                {filteredIncidencesData && filteredIncidencesData.length > 0 ? (
                    <div style={{width: containerWidth, overflowX: 'auto', overflowY: 'hidden', position: 'relative', minWidth: 0}} className='rounded-md'>
                        <div style={{display: 'flex', minWidth: 'min-content'}}>
                            {/* Colonne Catégorie - Texte vertical */}
                            <div style={{width: 30, minWidth: 30, backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden', flexShrink: 0}}>
                                {/* Ligne intermédiaire - indice 0 (1 ligne) */}
                                <div style={{height: emptyRowHeight, backgroundColor: 'transparent'}}></div>

                                {/* Dépenses - 8 lignes (indices 1-8) */}
                                <div style={{height: normalRowHeight * 8.5, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc'}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 10, fontWeight: 'bold', color: '#666'}}>
                                        Dépenses
                                    </div>
                                </div>

                                {/* Ligne intermédiaire - indice 9 (1 ligne) */}
                                <div style={{height: emptyRowHeight, backgroundColor: 'transparent'}}></div>

                                {/* Recettes - 8 lignes (indices 10-17) */}
                                <div style={{height: normalRowHeight * 8, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc'}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 10, fontWeight: 'bold', color: '#666'}}>
                                        Recettes
                                    </div>
                                </div>

                                {/* Lignes finales - 5 lignes */}
                                {Array(5).fill(null).map((_, i) => (
                                    <div key={i + 18} style={{height: normalRowHeight, backgroundColor: 'transparent'}}></div>
                                ))}
                            </div>

                            {/* Colonne Figée - Libellés */}
                            <div style={{minWidth: 150, maxWidth: 200, backgroundColor: 'transparent', flexShrink: 0}}>
                                {/* Header */}
                                <div style={{display: 'flex', height: 30, alignItems: 'center', padding: '0 6px', backgroundColor: blue, fontWeight: 'bold', minHeight: 30, position: 'sticky', left: 0, top: 0, zIndex: 12}}>
                                    <p style={{color: 'white', margin: 0, fontSize: fontsize * 0.8}}>Libellé</p>
                                </div>

                                {/* Lignes */}
                                {fieldsList.map((row, idx) => (
                                    <div key={idx} style={{display: 'flex', height: row.isEmpty ? emptyRowHeight : normalRowHeight, alignItems: 'center', padding: '0 6px', borderBottom: row.isEmpty ? 'none' : '1px solid #ddd', backgroundColor: row.isEmpty ? 'transparent' : (row.isCalculated ? '#f0f0f0' : '#ffffff'), minHeight: row.isEmpty ? emptyRowHeight : normalRowHeight, position: 'sticky', left: 0, zIndex: 11}}>
                                        <p style={{margin: 0, fontSize: fontsize * 0.8, fontWeight: row.isBold ? 'bold' : 'normal'}}>{row.label}</p>
                                    </div>
                                ))}
                            </div>

                            {/* Colonnes de données */}
                            <div style={{display: 'flex', flex: 1}}>
                                {filteredIncidencesData.map((row, yearIdx) => (
                                    <div key={yearIdx} style={{width: columnDataWidth, minWidth: columnDataWidth, display: 'flex', flexDirection: 'column', flexShrink: 0}}>
                                        {/* Header année */}
                                        <div style={{display: 'flex', height: 30, alignItems: 'center', justifyContent: 'center', padding: '0 3px', backgroundColor: blue, fontWeight: 'bold', minHeight: 30, borderBottom: '1px solid #ddd', position: 'sticky', top: 0, zIndex: 10}}>
                                            <p style={{marginTop: 0, color: 'white', fontSize: fontsize * 0.9}}>
                                                {row.annee}
                                            </p>
                                        </div>

                                        {/* Données */}
                                        {fieldsList.map((field, idx) => (
                                            <div key={idx} style={{display: 'flex', height: field.isEmpty ? emptyRowHeight : normalRowHeight, borderBottom: field.isEmpty ? 'none' : '1px solid #ccc', alignItems: 'center', justifyContent: 'center', minHeight: field.isEmpty ? emptyRowHeight : normalRowHeight, backgroundColor: field.isEmpty ? 'transparent' : field.isCalculated ? '#f0f0f0' : '#ffffff', padding: '0 2px', borderLeft: '1px solid #ddd'}}>
                                                {!field.isEmpty && (
                                                    <div style={{width: '100%', height: '100%', fontSize: fontsize * 0.7, textAlign: 'center', fontWeight: field.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', color: field.label === 'Solde opération' && parseFloat(row[field.key]) < 0 ? '#FF0000' : '#000', padding: '0 2px'}}>
                                                        {formatNumber(row[field.key])}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                        <p style={{color: '#999', fontSize: fontsize}}>Aucune donnée disponible</p>
                    </div>
                )}
            </div>
            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '5%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page5IncidencesFinancieresHypPart2;
